export const environment = {
  production: true,
  staging: false,
  redirectIfNotInIframe: false,
};
